<script>
import MethodButtonBase from './MethodButtonBase';
export default {
  name: 'FinnishTrustNetworkButton',
  components: {
    MethodButtonBase,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      {{ $t('online-bank') }}
    </template>
  </MethodButtonBase>
</template>
